import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { responseDefaultForm } from '../../../../shared/utils/utils'
import { MatButton } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ItinerariesItemProposalCreateFormComponent } from '../itineraries-item-proposal-create/itineraries-item-proposal-create-form/itineraries-item-proposal-create-form.component'
import { ItinerariesItemProposalEditFormComponent } from './itineraries-item-proposal-edit-form/itineraries-item-proposal-edit-form.component'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'itineraries-item-proposal-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatButton,
    FormClientSearchComponent,
    MatProgressBar,
    JsonPipe,
  ],
  templateUrl: './itineraries-item-proposal-edit.component.html',
  styleUrl: './itineraries-item-proposal-edit.component.scss',
  providers: [ItinerariesService],
  standalone: true,
})
export class ItinerariesItemProposalEditComponent
  implements OnInit, AfterViewInit
{
  constructor(
    private dialog: MatDialog,
    private itinerariesService: ItinerariesService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  itemsList: any[] = []

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() itemProposal: any = {}
  @Input() proposal: any = {}
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  loading: boolean = true
  columns: any[] = [
    {
      keyColumn: 'description',
      key: 'localParada',
      description: 'Descrição',
    },
    {
      keyColumn: 'postalCode',
      key: 'cep',
      description: 'Cep',
    },
    {
      keyColumn: 'street',
      key: 'logradouro',
      description: 'Logradouro',
    },
    {
      keyColumn: 'number',
      key: 'numero',
      description: 'Numero',
    },
    {
      keyColumn: 'neighborhood',
      key: 'bairro',
      description: 'Bairro',
    },
    {
      keyColumn: 'city',
      key: 'cidade',
      description: 'Cidade',
    },
    {
      keyColumn: 'areaTarrif',
      key: 'areaTarifario',
      description: 'Área Tarifário',
    },
    {
      keyColumn: 'latitude',
      key: 'latitude',
      description: 'Latitude',
    },
    {
      keyColumn: 'longitude',
      key: 'longitude',
      description: 'Longitude',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  page: number = 1
  rows: number = 10
  numberRows: number = 0

  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'description',
    'postalCode',
    'street',
    'number',
    'neighborhood',
    'city',
    'areaTarrif',
    'action',
  ]

  inputSearchContact: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'tipoContatoId',
      description: 'Tipo Contato',
      type: 'number',
      visible: false,
    },
    {
      id: 'descricao',
      description: 'Descrição',
      type: 'string',
      visible: true,
    },
  ]
  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getItinerariesByItemProposal()
    if (
      this.proposal.statusPropostaId == 1 ||
      this.proposal.statusPropostaId == 5 ||
      this.proposal.statusPropostaId == 6 ||
      this.proposal.statusPropostaId == 9
    ) {
      let index = this.displayedColumns.findIndex((ele) => {
        return ele == 'action'
      })
      if (index >= 0) {
        this.displayedColumns.splice(index, 1)
      }
    }
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchContact()
    } else {
      this.getItinerariesByItemProposal()
    }
  }

  getItinerariesByItemProposal() {
    this.loading = true
    this.itinerariesService
      // .listPagedItinerariesByItemPropose(
      .listPagedItinerariesStopByItemPropose(
        this.itemProposal.id,
        this.page,
        this.rows,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchContact() {
    this.loading = true
    this.itinerariesService
      .searchPagedItineraries(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.numberRows = response.totalItens
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.itinerariesService.deleteItineraries(element.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadList()
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.success(err.message)
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    let model: any = { itemProposal: this.itemProposal }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  editItem(element: any) {
    const dialogRef = this.dialog.open(
      ItinerariesItemProposalEditFormComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '900px',
        data: {
          itemProposalId: this.itemProposal.id,
          edit: true,
          item: element,
        },
      },
    )
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  createItineraries() {
    const dialogRef = this.dialog.open(
      ItinerariesItemProposalEditFormComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '900px',
        data: {
          edit: false,
          itemProposalId: this.itemProposal.id,
        },
      },
    )
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
